import { GoogleTagManager, sendGTMEvent } from "@next/third-parties/google";

import { env } from "~/env.mjs";
import { analytics } from "./AnalyticsProvider";

// lib/gtm.ts
type WindowWithDataLayer = Window & {
  dataLayer: Record<string, any>[];
};

const GTM_ID = env.NEXT_PUBLIC_GTM_ID;

export default function GTM() {
  return (GTM_ID && <GoogleTagManager gtmId={GTM_ID} />) || null;
}

export const trackEvent = (event: string, data: Record<string, any>) => {
  analytics.trackEvent(event, data);
  if (GTM_ID) {
    return sendGTMEvent({ event, data });
  }
};
